/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

const toastr  = require('toastr');
window.toastr = toastr;

const Swal  = require('sweetalert2');
window.Swal = Swal;

require('parsleyjs');
require('parsleyjs/dist/i18n/en');
require('parsleyjs/dist/i18n/hu');

window.Parsley = Parsley;

$(function () {
    Parsley.setLocale($("html").attr('lang'));
    window.Parsley.setLocale($("html").attr('lang'));
});

/**
 * Dropdown menu
 */
import('./partials/dropdown-menu');

/**
 * Go Top
 */
import('./partials/go-top');

/**
 * Tooltip
 */
import('./partials/tooltip');

$(document).ready(function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

});

window.showAlerts = function showAlerts(message, type, title, options) {
    switch (type) {
        case 'info':
            toastr.info(message, title, options);
            break;

        case 'warning':
            toastr.warning(message, title, options);
            break;

        case 'success':
            toastr.success(message, title, options);
            break;

        case 'error':
            toastr.error(message, title, options);
            break;
        default:
            toastr.info(message, title, options);
            break;
    }
}

window.ShowModalMessage =
    function (title, message, type, size) {
        $("#messageModal .modal-title").html(title);
        $("#messageModal .modal-body").html(message);

        $("#messageModal .modal-header").removeClass('bg-primary bg-info bg-warning bg-danger bg-success text-white');
        $("#messageModal .modal-dialog").removeClass('modal-xl modal-lg modal-sm');

        var headerClass = "";
        switch (type) {
            case 'success':
                headerClass = "bg-success text-white";
                break;
            case 'error':
                headerClass = "bg-danger text-white";
                break;
            case 'warning':
                headerClass = "bg-warning text-white";
                break;
            case 'info':
                headerClass = "bg-info text-white";
                break;
            default:
                headerClass = "bg-primary text-white";
                break;

        }
        $("#messageModal .modal-header").addClass(headerClass);
        $("#messageModal .modal-dialog").addClass(size);
        $("#messageModal").modal("show");
    }

import AirDatepicker
    from 'air-datepicker';
// import 'air-datepicker/air-datepicker.css';
import localeHu
    from 'air-datepicker/locale/hu';

import localeEn
    from 'air-datepicker/locale/en';
import {createPopper} from '@popperjs/core';

var airLocale = localeHu;

if ($("html").attr("lang") == "en") {
    airLocale = localeEn;
}

window.AirDatepicker = AirDatepicker;

var datepickers = [];

window.addAirDatepicker = function addAirDatepicker(el, isTimePicker) {
    var opts = {
        locale    : airLocale,
        dateFormat: 'yyyy-MM-dd',
        container : '#scroll-container',
        visible   : false,
        timepicker: isTimePicker,
        timeFormat: 'HH:mm',
        onSelect  : function (event) {
            $(event.datepicker.$el).trigger("change")
        },
        position({
                     $datepicker,
                     $target,
                     $pointer,
                     done
                 }) {
            let popper = createPopper($target, $datepicker, {
                placement: 'top',
                modifiers: [
                    {
                        name   : 'flip',
                        options: {
                            padding: {
                                top: 64
                            }
                        }
                    },
                    {
                        name   : 'offset',
                        options: {
                            offset: [0, 20]
                        }
                    },
                    {
                        name   : 'arrow',
                        options: {
                            element: $pointer
                        }
                    }
                ]
            })

            /*
             Return function which will be called when `hide()` method is triggered,
             it must necessarily call the `done()` function
              to complete hiding process
            */
            return function completeHide() {
                popper.destroy();
                done();
            }
        }
    };

    $.each(el[0].attributes, function (i, attrib) {
        if (attrib.name.indexOf('data-air-') === 0) {
            var key   = attrib.name.replace('data-air-', '');
            key       = key.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
            });
            key       = key.charAt(0).toLowerCase() + key.slice(1);
            var value = attrib.value;

            opts[key] = value;
        }
    });
    datepickers[el.attr("name")] = new AirDatepicker(el.get(0), opts);

    el.on('keypress', function (event) {
        return restrictInput(this, event, dateOnly);
    });

    el.parent().find(".calendar-addon").on("click", function () {
        $(this).parent().find("input[type=text].date-picker").focus();
    });

    window.datepickers = datepickers;
}

$('input[type=text].datetime-picker').each(function () {

    var el = $(this);

    if (!el.prop('readonly')) {
        window.addAirDatepicker(el, true);
    }

});

$('input[type=text].date-picker').each(function () {

    var el = $(this);

    if (!el.prop('readonly')) {
        window.addAirDatepicker(el, false);
    }

});

$('document').ready(function () {
    var fh = $("footer").outerHeight();
    $("#content_container").css("padding-bottom", fh + 40 + "px");
});


